import { FC } from "react";
import { IOpsProps } from "../IOpsProps";
import NotYetImpl from "../not-yet-impl/NotYetImpl";
import Operation from "../Operation";

export type OrgOps = 'add_contract_admin' | 'add_contract_member' | 'remove_user' | 'verify_admin' | 'update_address' | 'add_teachers_to_organizations';

export const orgOpsMap: Record<OrgOps, FC> = {
  add_contract_admin: NotYetImpl,
  add_contract_member: NotYetImpl,
  remove_user: NotYetImpl,
  verify_admin: NotYetImpl,
  update_address: NotYetImpl,
  add_teachers_to_organizations: NotYetImpl,
};

export interface OrgOpsProps extends IOpsProps {
  ops: OrgOps[];
};

const OrgOps: FC<OrgOpsProps> = (props) => {

  const operations = props.ops.map((value: OrgOps) => {
    return (
      <Operation name={value} key={value}>
        { orgOpsMap[value]({}) }
      </Operation>
    );
  });

  return (
    <>
    {operations}
    </>
  );
}

export default OrgOps;
